import { useCallback } from 'react';
import { Address as AccountAddress } from 'shared/types/account';
import useLocale from 'helpers/hooks/useLocale';
import { useAccount } from 'frontastic';
import { Address } from '../types';

const useMappers = () => {
  const { account } = useAccount();
  const { getCountry } = useLocale();

  const accountAddressToAddress = useCallback(
    (address: AccountAddress) => {
      return {
        addressId: address.addressId,
        title: address.title,
        firstName: address.firstName,
        lastName: address.lastName,
        email: account?.email ?? '',
        phone: address.phone,
        line1: address.streetName ?? '',
        line2: address.additionalAddressInfo,
        postalCode: address.postalCode ?? '',
        city: address.city ?? '',
        state: address.state,
        county: address.county,
        country: address.country,
        custom: address.custom,
      } as Address;
    },
    [account],
  );

  const addressToAccountAddress = useCallback(
    (address: Address) => {
      return {
        addressId: address.addressId,
        title: address.title,
        firstName: address.firstName,
        lastName: address.lastName,
        email: address.email,
        phone: address.phone,
        streetName: address.line1,
        additionalAddressInfo: address.line2,
        postalCode: address.postalCode,
        city: address.city,
        country: address.country || getCountry(),
        state: address.state,
        county: address.county,
        custom: address.custom,
      } as AccountAddress;
    },
    [getCountry],
  );

  return { addressToAccountAddress, accountAddressToAddress };
};

export default useMappers;
